export const TOOL_LABELS: Record<string, string> = {
  list_projects: "Projekte",
  list_sites: "Liegenschaften",
  list_generators: "Erzeuger",
  get_site: "Liegenschaftdetails",
  search: "Suchergebnisse",
  list_invoices: "Rechnungen",
  list_credit_notes: "Gutschriften",
  get_credit_note: "Gutschrift",
  list_blocked_credit_notes: "Blockierte Gutschriften",
  credit_note_total: "Gesamtbetrag Gutschriften",
  credit_note_monthly_breakdown: "Monatliche Gutschriften"
};

export const COLUMN_LABELS: Record<string, string> = {
  id: "ID",
  name: "Name",
  active: "Aktiv",
  city: "Stadt",
  project_id: "Projekt-ID",
  project_name: "Projekt",
  type: "Typ",
  site_id: "Liegenschaft-ID",
  installed_capacity: "Leistung (kW)",
  tool_name: "Tool"
};
